import { Card, css, styled } from '@mui/material'
import { Z_INDEX_DEFAULT_VALUE } from 'redesign/shared/zIndex/constants'

export const MuiCard = styled(Card, {
  shouldForwardProp: (prop) =>
    prop !== 'isNew' && prop !== 'isClickable' && prop !== 'isNative' && prop !== 'hasBorder',
})<{ isNew: boolean; isClickable?: boolean; isNative?: boolean; hasBorder?: boolean }>`
  position: relative;
  background-color: ${({ theme }) => theme.palette.background.base};
  border-radius: 0;
  box-shadow: none;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};

  min-height: fit-content;
  border-bottom: ${({ hasBorder, theme }) => (hasBorder ? `1px solid ${theme.palette.common.divider}` : 'none')};

  ${({ isNative, theme, isClickable }) =>
    !isNative &&
    isClickable &&
    css`
      :hover::before {
        background-color: ${theme.palette.secondary.hover};
      }
    `}

  ::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: ${Z_INDEX_DEFAULT_VALUE};
    background-color: ${({ isNew, theme }) => (isNew ? theme.palette.secondary.selected : 'none')};
  }
`

export const Content = styled('div')`
  text-decoration: none;
`
